import { React, useEffect } from "react";
import { getLocalSessionData } from "../../utils/Authentication/handleUserSession";
import { LOCALSESSIONDATAKEYS } from "../../constants/AppConstants";
import { getNativeAppQueryParamsValuesByKey, removeNativeAppStorageItems } from "../../constants/AppMethod";
import Loader from "../../components/shared/loader/Loader";
import { useDispatch } from "react-redux";
import { NativeAppLogsInit } from "../../store/NativeAppLogs/NativeAppLogsSlice";

const NativeAppRedirectionHandler = () => {
    const dispatch = useDispatch();
    const redirectURI = getNativeAppQueryParamsValuesByKey("redirect_uri");
   
    const navigateToNativeApp = () => {
        const authTokenInfo = JSON.parse(getLocalSessionData(LOCALSESSIONDATAKEYS.NATIVE_APP_AUTH_TOKEN_INFO));
        const stateAttributeQS = getNativeAppQueryParamsValuesByKey("state");
        const authTokenInfoUpdated = authTokenInfo?.includes('state=')
        ? authTokenInfo.replace(/([?&]state=)[^&]*/, `$1${stateAttributeQS}`)
        : (stateAttributeQS)
            ? `?state=${stateAttributeQS}${authTokenInfo.replace(/^\?/, '&')}`
            : authTokenInfo;
        const webToAppURL = `${redirectURI?.replace(/\/$/, '')}${authTokenInfoUpdated || ''}`;
        dispatch(NativeAppLogsInit({isWebToApp: true, webToAppRequestURL: webToAppURL}));
        removeNativeAppStorageItems();
        window.open(`${webToAppURL}`, '_self');
    }

    useEffect(() => {
        navigateToNativeApp();
        // eslint-disable-next-line
    }, [])

    return <Loader />
}

export default NativeAppRedirectionHandler;